/**
 * 政情管理
 */
import { createAPI } from '@common'

export default {
  // 政情管理-获取分组列表
  getGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'get', config),
  // 政情管理-修改分组信息
  putGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'put', config),
  // 政情管理-新增分组
  postGroups: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut', 'post', config),
  // 政情管理-修改分组信息
  putLeaderGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0dbut', 'put', config),
  // 政情管理-删除分组的校验
  getFolderUsedByCols: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.dpmvno0dpmvnot0gpmefsVtfeCzDpmt', 'get', config, {
      neverLoading: true
    }),
  // 政情管理-删除分组
  deleteGroups: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efmfuf', 'post', config),
  // 政情管理-分组详情
  getGroupsDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0dbut0efubjm', 'get', config),
  // 政情管理-创建人物
  postLeader: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs', 'post', config),
  // 政情管理-修改人物
  putLeader: (config) => createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs', 'put', config),
  // 政情管理-获取人物详情
  getLeaderDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0efubjm', 'get', config),
  // 政情管理-删除人物
  deleteLeader: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0efmfuf', 'post', config),
  // 政情管理-更新排序
  postLeaderOrder: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0psefs', 'post', config),
  // 政情管理-更新排序
  postLeaderMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0npwf', 'post', config),
  //获取稿件列表
  getDetailListByIDs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0hfuEfubjmMjtuCzJEt', 'get', config),
  // 报料-修改分组信息
  saveTifGroup: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0ujqpgg0dbut', 'put', config),
  // 政情管理-跨页调序
  orderLeader: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.ojt0ojt0mfbefs0sfpsefs', 'post', config)
}
